const DashboardView = () => import("@views/dashboard/dashboard-view.vue");
import DashboardComplete from "@views/dashboard/dashboard-complete.vue";
import DashboardPreberiVec from "@views/dashboard/dashboard-read-more.vue";

export const dashboardRoutes = [
    {
        component: DashboardView,
        name: "dashboard",
        path: "dashboard",
        redirect: { name: "dashboard_dashboard" },
        children: [
            {
                component: DashboardComplete,
                name: "dashboard_dashboard",
                path: "home"
            },
            {
                component: DashboardPreberiVec,
                name: "dashboard_preberivec",
                path: "preberivec"
            }

        ]
    },
];